"use client"

import dynamic from 'next/dynamic';

// Dynamically import ReactPlayer to avoid SSR issues
const ReactPlayer = dynamic(() => import('react-player'), { ssr: false }) as any;

interface AuthorVideoProps {
  videoUrl?: string;
  nativeAssetUrl?: string;
}

export function AuthorVideo({ videoUrl, nativeAssetUrl }: AuthorVideoProps) {
  const url = nativeAssetUrl || videoUrl;

  if (!url) return null;

  return (
    <div className="w-full aspect-video rounded-sm overflow-hidden bg-black border border-border shadow-2xl relative group">
      <ReactPlayer
        url={url}
        width="100%"
        height="100%"
        controls
      />
    </div>
  );
}
